<template>
	<div style="position: fixed;left:0px;top:0px;width:100%;height:100%;background: #fff;z-index: 999;;">
		<img
			src="@/assets/images/appbg.jpg"
			style="width:100%;height:100%;"
		/>

		<div style="position: absolute;left:0px;top:0px;width:100%;height:100%;display: flex;flex-direction:column;align-items: center;justify-content: center;">
			<div style="color:#fff;font-size:30px;font-weight: bold;padding-bottom:40px;">欢迎使用全产业物流平台</div>

			<div style="width:1024px;height:500px;background-color: rgba(255, 255, 255, 0.7);border-radius:20px;">
				<div style="display: flex;align-items: center;justify-content:flex-start;flex-wrap: wrap;padding:20px 0px;">
					<div
						v-for="item in appList"
						@click="goAppRouter(item.code,item.name)"
						:key="item.id"
						style="margin-left:40px;margin-right:40px;margin-bottom:40px;display: flex;flex-direction: column;cursor: pointer;align-items: center;justify-content: center;"
					>
						<div style="border-radius: 50%;padding:20px;overflow: hidden;background-color: #fff;">
							<img
								:src="appImage[item.code]"
								style="width:80px;height:80px;display: block;overflow: hidden;"
							/>
						</div>
						<div style="text-align: center;color: #fff;margin-top:15px;font-size:12px;background-color: #409EFF;padding:2px 2px;border-radius: 5px;">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>

		<div
			v-if="showClose"
			@click="closeAppChange"
			style="position: absolute;top:30px;right:30px;background:#409EFF;padding:5px 10px;border-radius: 10px;cursor: pointer;z-index: 100;"
		>
			<span style="color:#fff;">关闭</span>
		</div>
	</div>
</template>
<script>
import { getApplicationCode, setApplicationCode } from "@/utils/user";
import {
	returnBylocalStorageData,
	saveBysessionStorage,
} from "@/utils/storage";

var platform=require("@/assets/images/platform.png");
var supervise=require("@/assets/images/supervise.png");
var logistics=require("@/assets/images/logistics.png");
var system=require("@/assets/images/system.png");
var mobile=require("@/assets/images/mobile.png");

export default {
	props: ["showClose"],
	mounted() {
		this.appList = returnBylocalStorageData("LOCAL_APP_LIST");
	},
	data() {
		return {
			homeData: getApplicationCode(),
			appList: [],
			allEmpNumber: 0,
			allEmpNumberTwo: 0,
			appImage:{
				platform,supervise,logistics,system,mobile
			}
		};
	},
	methods: {
		closeAppChange() {
			this.$emit("closeAppChange");
		},
		goAppRouter(code,name) {
			this.$confirm(`是否切换到[${name}]?`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					//设置当前应用code
					setApplicationCode(code);
					saveBysessionStorage(
						"HISTORY_TOP_TABMENULIST",
						JSON.stringify([])
					);
					saveBysessionStorage(
						"ACTIVE_HISTORY_TSB_ITEM",
						JSON.stringify("")
					);
					this.$router.replace({
						name: "home",
					});
					window.location.reload(true);
				})
				.catch(() => {});
		},
	},
};
</script>
